function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawTasting = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 883.34 785.3",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 586.34,
    y1: 777.6,
    x2: 586.34,
    y2: 296.43,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 665.58,
    y1: 818.95,
    x2: 665.58,
    y2: 130.43,
    gradientTransform: "matrix(-1 0 0 1 1038 0)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 832.33,
    y1: 380.69,
    x2: 1046.36,
    y2: 380.69,
    gradientTransform: "matrix(-1 0 0 1 1874 0)",
    xlinkHref: "#prefix__a"
  })), React.createElement("ellipse", {
    cx: 428.11,
    cy: 662.98,
    rx: 428.11,
    ry: 122.32,
    fill: "#f5f5f5"
  }), React.createElement("path", {
    d: "M660.23 392.82s-53 37.48-39 109-74.44 171.26-74.44 171.26h2.18c95.73-.47 160.12-98.82 122-186.63-14.15-32.64-24.02-69.8-10.74-93.63z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M660.23 392.82s-35 51.08-17.27 100.7-25.15 173-96.14 179.56",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M709.43 589.65s-50.21-17.07-62.85 28.39-108.31 35.61-108.31 35.61.54.53 1.57 1.48c69.29 64.64 147.12 58.84 147.54-11.15.16-26.01 4.86-51.33 22.05-54.33z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M709.43 589.65s-50.21-17.07-62.85 28.39-108.31 35.61-108.31 35.61.54.53 1.57 1.48c69.29 64.64 147.12 58.84 147.54-11.15.16-26.01 4.86-51.33 22.05-54.33z",
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M709.43 589.65s-41.58 1.93-44.54 38.92-73.22 69.88-126.62 25.08",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M779.61 543.22c3-15 2.31-36.85-22.23-47.49 13.12-21.09 6.95-36-4.91-41.29-.08-5.5-1.52-16.66-11.18-22.65 1.28-10.38 3.36-51.64-43.26-56.26-5.47-9.44-22.59-35-50.48-42.08v-37c-6.72 14.11-49 22.17-49 22.17-48.46 6.77-59.33 34.15-61.78 46.11-6.24.19-11.73 1-14.82 2.94-10.16 6.35-82.68 25.3-77 75.54-1 .34-1.94.68-2.91 1 0 0-39.67 31.65-29 56.82l-4 .29s-23 14.22-15.93 42.24a8.45 8.45 0 0 0-2 7.69l54.69 182.29a5.86 5.86 0 0 0 2.2 3.16c2.47 1.72 7.6 5.15 15.08 9.31l.06.29.33-.07a245.79 245.79 0 0 0 26.32 12.55v.21l.33-.06c6.34 2.57 13.29 5.09 20.8 7.41v.16h.33c6.95 2.13 14.37 4.09 22.22 5.75v.1h.33c7.37 1.55 15.13 2.83 23.23 3.75h.31a246.37 246.37 0 0 0 30 1.52h.67a246.48 246.48 0 0 0 28.06-2h.33v-.06q11.29-1.46 23.09-4.09l-.08.78.67.07.1-1q11.77-2.68 24-6.69h.33v-.16q10.16-3.37 20.59-7.74l.33.06v-.22q12.09-5.11 24.5-11.71l.33.07.06-.28q7-3.75 14.11-8a5.88 5.88 0 0 0 2.6-3.36l54.51-182.43a8.46 8.46 0 0 0-2-7.67z",
    transform: "translate(-158.33 -57.35)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M537.48 327.46s-24.6-50.5-71.22-45.32 3.24 53.09 3.24 53.09 56.98 4.53 67.98-7.77z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M537.48 327.46s-24.6-50.5-71.22-45.32 3.24 53.09 3.24 53.09 56.98 4.53 67.98-7.77z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M379.51 319.04s0-.66.12-1.82c.83-8.09 7.46-40.67 60.09-48 0 0 40.79-7.77 47.26-21.37v41.44s-8.42 29.14-50.5 38.85-56.97-9.1-56.97-9.1z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M257.14 445.29s-30.47 18.78-9.07 55.68 361.28 0 361.28 0 22-45.32-17.48-61.51-334.73 5.83-334.73 5.83z",
    fill: "#784f69"
  }), React.createElement("path", {
    d: "M588.42 401.39c-.08-5.3-1.47-16-10.78-21.82 1.23-10 3.25-49.77-41.69-54.22-5.28-9.1-21.76-33.78-48.65-40.55v-35.69c-6.47 13.6-47.26 21.37-47.26 21.37-46.7 6.53-57.18 32.91-59.53 44.43-6 .18-11.3 1-14.28 2.83-9.79 6.12-79.68 24.38-74.25 72.8-.94.32-1.87.66-2.8 1 0 0-55.1 44-15.15 68.31s18.39 35.29 72.13 8.09l.17-.11c20.24 5.81 74.47 18 106.66-6.37l2.31-1.75c12.8 7.63 43.13 21.58 68.91 1.75l.22-.17c10 9.41 30.35 21.39 54.81-3.07 29.29-29.26 23.6-50.37 9.18-56.83z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M517.41 452.41s26.55 39.49 61.51 4.53 20.07-58.27 0-58.92-61.51 54.39-61.51 54.39z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M517.41 452.41s26.55 39.49 61.51 4.53 20.07-58.27 0-58.92-61.51 54.39-61.51 54.39z",
    opacity: 0.15
  }), React.createElement("path", {
    d: "M587.99 403.21s6.47-55-77-12.95-62.16 64.1-62.16 64.1 41.44 31.73 75.1 5.83 54.34-33.67 64.06-56.98z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M587.99 403.21s6.47-55-77-12.95-62.16 64.1-62.16 64.1 41.44 31.73 75.1 5.83 54.34-33.67 64.06-56.98z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M523.89 386.37s-31.73-22-80.28 0-105.54 77.7-105.54 77.7 74.46 26.58 114.6-3.89 69.28-53.09 71.22-73.81z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M523.89 386.37s-31.73-22-80.28 0-105.54 77.7-105.54 77.7 74.46 26.58 114.6-3.89 69.28-53.09 71.22-73.81z",
    opacity: 0.07
  }), React.createElement("path", {
    d: "M458.5 383.14s-64.75-9.06-94.53 9.06-90.3 66.37-90.3 66.37 18.39 35.29 72.13 8.09c.04-.01 111.4-69.28 112.7-83.52z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M458.5 383.14s-64.75-9.06-94.53 9.06-90.3 66.37-90.3 66.37 18.39 35.29 72.13 8.09c.04-.01 111.4-69.28 112.7-83.52z",
    opacity: 0.03
  }), React.createElement("path", {
    d: "M288.86 390.26s-57.62 46-12.3 69.93c0 0 95.82-62.8 97.77-69.93 0 0-44.66-15.54-85.47 0z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M414.47 316.45s-38.2-6.47-48.56 0-88.05 26.55-72.52 81.58l23.28-8.38s44.71-56.37 97.8-73.2z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M414.47 316.45s-38.2-6.47-48.56 0-88.05 26.55-72.52 81.58l23.28-8.38s44.71-56.37 97.8-73.2z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M477.92 324.87s-27.19-25.25-87.41-1.94-80.28 65.39-80.28 65.39l90.32 6.8s50.82-72.84 77.37-70.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M477.92 324.87s-27.19-25.25-87.41-1.94-80.28 65.39-80.28 65.39l90.32 6.8s50.82-72.84 77.37-70.25z",
    opacity: 0.07
  }), React.createElement("path", {
    d: "M520 328.1s-43.38-14.24-77 5.18-46 57.62-46 57.62l53.74-2.59s42.07-66.03 69.26-60.21z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M520 328.1s-43.38-14.24-77 5.18-46 57.62-46 57.62l53.74-2.59s42.07-66.03 69.26-60.21z",
    opacity: 0.03
  }), React.createElement("path", {
    d: "M576.98 380.55s14.89-75.75-83.52-52.44c0 0-55.93 49.21-40.26 62.8s123.78-10.36 123.78-10.36z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M239.81 492.12l52.7 175.67a5.65 5.65 0 0 0 2.17 3c14.71 10.29 127.89 83.3 266.49 0a5.67 5.67 0 0 0 2.5-3.24l52.53-175.8a5.67 5.67 0 0 0-6.81-7.12l-22.82 5.7a5.67 5.67 0 0 1-2.4.08l-21.45-4a5.67 5.67 0 0 0-3.7.57l-25.46 13.58a5.67 5.67 0 0 1-4 .5l-27.39-6.81a5.67 5.67 0 0 0-3.14.11l-31.81 10.41a5.67 5.67 0 0 1-4.35-.34l-21.07-10.78a5.67 5.67 0 0 0-4.31-.36l-27.17 8.67a5.67 5.67 0 0 1-2.12.25l-26.16-1.83a5.67 5.67 0 0 1-1.16-.2l-20.76-5.93a5.67 5.67 0 0 0-2.69-.1l-28.76 5.84a5.67 5.67 0 0 1-3.22-.28l-28-11.09a5.67 5.67 0 0 0-3.09-.31l-22.29 4a5.67 5.67 0 0 1-2.7-.17l-22.46-7.06a5.67 5.67 0 0 0-7.1 7.04z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M239.81 493.41l52.7 175.67a5.65 5.65 0 0 0 2.17 3c14.71 10.29 127.89 83.3 266.49 0a5.67 5.67 0 0 0 2.5-3.24l52.53-175.8a5.67 5.67 0 0 0-6.81-7.12l-22.8 5.73a5.67 5.67 0 0 1-2.4.08l-21.45-4a5.67 5.67 0 0 0-3.7.57l-25.46 13.58a5.67 5.67 0 0 1-4 .5l-27.38-6.84a5.67 5.67 0 0 0-3.14.11l-31.81 10.41a5.67 5.67 0 0 1-4.35-.34l-21.07-10.8a5.67 5.67 0 0 0-4.31-.36l-27.17 8.67a5.67 5.67 0 0 1-2.12.25l-26.19-1.83a5.67 5.67 0 0 1-1.16-.2l-20.76-5.93a5.67 5.67 0 0 0-2.69-.1l-28.76 5.86a5.67 5.67 0 0 1-3.22-.28l-28-11.09a5.67 5.67 0 0 0-3.09-.31l-22.29 4a5.67 5.67 0 0 1-2.7-.17l-22.46-7.06a5.67 5.67 0 0 0-7.1 7.04z",
    fill: "#4d4981"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.5,
    d: "M297.62 430.78l-5.51-1.92-3.09-4.95 13.74-17.2 5.51 1.92 3.09 4.95-13.74 17.2zM558.55 459.92l-5.52-1.92-3.08-4.95 13.73-17.2 5.51 1.91 3.09 4.95-13.73 17.21zM443.95 366.03l-5.51-1.91-3.09-4.95 13.73-17.21 5.52 1.92 3.08 4.95-13.73 17.2zM474.88 429.29l-5.33 2.36-5.64-1.5-1.73-21.95 5.33-2.36 5.64 1.5 1.73 21.95zM385.08 375.41l-3.68 4.53-5.71 1.21-11.48-18.78 3.69-4.53 5.71-1.21 11.47 18.78zM378.61 428.5l-3.69 4.53-5.7 1.21-11.48-18.78 3.68-4.53 5.71-1.21 11.48 18.78zM536.96 433.67l-4.23 4.02-5.82.47-8.98-20.1 4.24-4.02 5.81-.47 8.98 20.1zM508.11 364.79l1.43-5.66 4.66-3.5 18.34 12.18-1.43 5.66-4.66 3.51-18.34-12.19z"
  }), React.createElement("path", {
    fill: "#fd6f8d",
    opacity: 0.5,
    d: "M313.16 373.16l-5.51-1.92-3.09-4.95 13.74-17.2 5.51 1.91 3.09 4.95-13.74 17.21zM382.54 340.82l-1.35-5.67 2.52-5.27 21.89 2.33 1.35 5.68-2.52 5.27-21.89-2.34zM488.62 308.54l1.09-5.73 4.45-3.78 19.02 11.08-1.09 5.73-4.45 3.78-19.02-11.08zM446.21 279.63l5.69-1.3 5.24 2.57-2.55 21.87-5.69 1.29-5.24-2.57 2.55-21.86zM407.15 452.19l-1.35-5.68 2.51-5.27 21.89 2.33 1.35 5.68-2.51 5.27-21.89-2.33zM326.21 456.34l-3.45-4.71.26-5.82 21.07-6.39 3.46 4.71-.27 5.83-21.07 6.38zM552.8 417.34l-4.79-3.33-1.63-5.61 17.87-12.85 4.79 3.33 1.63 5.6-17.87 12.86zM401.3 421.87l-4.79-3.33-1.64-5.6 17.87-12.86 4.79 3.33 1.64 5.6-17.87 12.86z"
  }), React.createElement("path", {
    d: "M294.4 488.31l-22.29 4a5.67 5.67 0 0 1-2.7-.17l-.37-.12 40.57 188-40.57-188-22.09-6.94a5.67 5.67 0 0 0-7.13 7l52.7 175.67a5.65 5.65 0 0 0 2.17 3c4.61 3.23 18.91 12.62 40.63 21.42l-39.29-204a5.66 5.66 0 0 0-1.63.14zM609.41 484.65l-22.82 5.7a5.67 5.67 0 0 1-2.4.08l-21.45-4a5.66 5.66 0 0 0-2 0l-37.5 203.7 37.48-203.69a5.67 5.67 0 0 0-1.68.58l-25.46 13.58a5.67 5.67 0 0 1-3.79.55l-26.72 196.56a280.26 280.26 0 0 0 44.15-19l40.89-188.75-40.9 188.69q6.94-3.7 14-7.92a5.67 5.67 0 0 0 2.5-3.24l52.53-175.8a5.67 5.67 0 0 0-6.83-7.04z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M529.54 501.09l-27.37-6.84a5.66 5.66 0 0 0-1.61-.16l-20.89 210.14q11.5-2.61 23.44-6.52l26.72-196.56z",
    fill: "#4d4981"
  }), React.createElement("g", {
    opacity: 0.5,
    fill: "#fff"
  }, React.createElement("path", {
    d: "M268.725 493.366l.636-.137 40.57 187.961-.636.137zM326.77 501.628l.644-.092 28.66 199.138-.643.092zM295.632 489.414l.638-.123L335.594 693.5l-.638.122zM358.465 495.174l.647-.057 18.666 211.227-.648.057zM393.714 502.545l.65-.02 6.086 207.521-.65.02zM427.611 497.63l.65-.004 1.382 213.905-.65.004zM456.378 709.582l8.322-202.78.65.027-8.322 202.78zM479.14 706.32l21.157-211.223.646.065-21.157 211.223zM499.373 696.267l26.026-198.198.643.084-26.026 198.199zM522.84 691.293l37.632-204.038.639.118-37.632 204.038zM546.965 679.948l40.78-188.776.635.138-40.78 188.775z"
  })), React.createElement("path", {
    d: "M207.92 697.1c6-2 15-4.28 22.09-3.47 6.74-2.46 22.6-8.88 33.43-18.39a241 241 0 0 1 .71-28.24c5.54-63-6.92-104.49-6.92-104.49s-9.78-31.67-8.71-57.95c-.63 1.19-1 1.9-1 1.9-.86-22.67-8.58-46.13-14.36-60.74a4.88 4.88 0 0 1-.65-.24l-6.59-15.34a13.31 13.31 0 0 1-1.22-2.83l-1-2.43.31-.13c-.1-.4-.21-.82-.31-1.25-4.13-17.47-7.28-58.9-7.28-58.9-11.09-43.6 15.21-70.6 15.21-70.6l44.63-38.41a5.66 5.66 0 0 0-.44 1.57l.37-.32c.63-1.8 1.32-4 2-6.44a33.93 33.93 0 0 1-4.46-3.77 34.27 34.27 0 0 1-10-17.85c-1.08-5.31-.87-10.78-.65-16.19l.74-18.52a58.81 58.81 0 0 1 1.1-10.8c3.37-14.74 18.43-25 33.54-25.65 4.81-.2 9.61.41 14.4.77a96.85 96.85 0 0 0 11.7.25 2.12 2.12 0 0 0 1.26-.33 1.85 1.85 0 0 0 .55-1.28 6.37 6.37 0 0 0-1.56-4.77 5.94 5.94 0 0 0-2-1.16l1.08.26a5.88 5.88 0 0 0-1.77-.95c3.86.91 7.81 1.86 11.13 4a14.38 14.38 0 0 1 2.6 2.19 11.35 11.35 0 0 1 3.76 7c1.73-1.69 3.39-3.55 4-5.87a5.93 5.93 0 0 0 0-2.84q.39.49.76 1c0-.1 0-.2-.07-.3a29.7 29.7 0 0 1 5.81 12 4.66 4.66 0 0 0 1.05-3.44c.22.68.43 1.37.62 2.07a4.79 4.79 0 0 0 .07-1.38 47.32 47.32 0 0 1 2.31 16.43c0 5.56-2.46 14.21-8.42 16.16-.3.1-.62.18-.94.25a37.35 37.35 0 0 1-25.19 57.05q-.14 1-.28 2.13h-.24c-.16 1.5-.29 3.08-.39 4.73a31.84 31.84 0 0 0 4.9 3.94 40.46 40.46 0 0 0 16.25 5.47 48.63 48.63 0 0 1 19.65 5.84c7.12 4 15 9.79 17.45 16.84 4.12 11.77 26.76 30 42 32.27l5.4-.31.39-.12v.1l1.32-.08h.43v.08l1.37-.08s.14.63.32 1.75c7.65-2.62 23.88-9.92 45-29.08 23.54-21.35 55.31-17.15 67.56-14.46a2.1 2.1 0 0 1 .56 3.89c-4.94 2.72-12.62 6.67-16.22 7.11 0 0 7.42 7.68-.46 11.78a5.67 5.67 0 0 1-5.93-.57c-3.79-2.77-14.33 3.51-29.59 6.78 0 0-43.08 44.58-64.45 51.48A30.74 30.74 0 0 1 423 347l-1.32-.11-.07.11h-.18l-.16 1.4s-33.25-1.75-44-13.82a17.32 17.32 0 0 1-2.11-2.25l11.56 145.48h-.11l.11 1.38h-8.5a320.62 320.62 0 0 0 2.28 53.63v94.8s.44 8.35-16.89 20.5A647.93 647.93 0 0 0 311 688.79l-2.1 1.82c3.19 29 9.86 83.08 15.42 85.1l-3.43.6c5.91 7.45 22.56 27.89 27.65 28.46 6.23.69 10.38 10.38 0 12.46-9.58 1.92-34.48 4.42-61.65-6.08a9.41 9.41 0 0 1-5.92-10l2-15.28a2.14 2.14 0 0 0-.88.93c-1.38 4.15 0-5.54 0-5.54a433 433 0 0 1-13.38-55.84l-20.52 17.78s-.42-.51-1.13-1.43c-5 11.44-14 34.81-12 51.95 2.77 23.53-23.53 2.77-20.76-11.07 2.24-11.2-7.75-58.64-11.65-76.34a7.89 7.89 0 0 1 5.27-9.21z",
    transform: "translate(-158.33 -57.35)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M264.46 255.85s19.6-3.38 48.65-29.73c23-20.85 54-16.74 66-14.12a2 2 0 0 1 .55 3.79c-4.83 2.65-12.33 6.51-15.84 6.95 0 0 7.24 7.5-.45 11.51a5.54 5.54 0 0 1-5.79-.56c-3.7-2.7-14 3.43-28.89 6.62 0 0-58.11 60.14-71.62 50zM164.45 174.09s-5.41 23 0 39.19l-24.32 3.37-21.62-10.8v-14.2s10.14-21.62 7.43-46.62z",
    fill: "#fec3be"
  }), React.createElement("path", {
    d: "M95.53 672.09s-17.57 34.46-14.86 57.43-23 2.7-20.27-10.81c2.19-10.93-7.57-57.26-11.37-74.54a7.7 7.7 0 0 1 5.12-9c8.13-2.67 21.72-6 28.56-.94 10.12 7.42 12.82 37.86 12.82 37.86zM162.43 709.92s23 29.73 29.06 30.41 10.14 10.14 0 12.16c-9.35 1.87-33.67 4.32-60.2-5.94a9.19 9.19 0 0 1-5.78-9.78l3.81-28.88z",
    fill: "#8b416f"
  }), React.createElement("path", {
    d: "M200.27 394.37l22 2.94s-5.14 36.92.26 77.47v92.57s.43 8.15-16.49 20a632.65 632.65 0 0 0-51.24 39.71l-61.32 53.12s-24.33-29.73-20.95-47.3c0 0 40.54-12.84 45.95-33.79 3.1-12 18.82-22 31.69-28.35 16.58-8.19 25.62-26.8 21.08-44.72a34.48 34.48 0 0 0-3.45-8.69c-10.81-18.92-26.35-61.49-26.35-61.49l29.73-56.76z",
    fill: "#4d4981"
  }), React.createElement("path", {
    d: "M200.27 394.37l22 2.94s-5.14 36.92.26 77.47v92.57s.43 8.15-16.49 20a632.65 632.65 0 0 0-51.24 39.71l-61.32 53.12s-24.33-29.73-20.95-47.3c0 0 40.54-12.84 45.95-33.79 3.1-12 18.82-22 31.69-28.35 16.58-8.19 25.62-26.8 21.08-44.72a34.48 34.48 0 0 0-3.45-8.69c-10.81-18.92-26.35-61.49-26.35-61.49l29.73-56.76z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M167.83 711.95s-39.87 6.76-41.22 10.81 0-5.41 0-5.41-23-69.6-17.57-131.09-6.76-102-6.76-102-14.19-45.95-6.08-72.3 93.25-14.87 93.25-14.87-29.73 69.56-29.05 102.69c0 0-3.38 100-9.46 111.49 0 0 9.46 97.98 16.89 100.68z",
    fill: "#4d4981"
  }), React.createElement("path", {
    d: "M163.1 191.65s-4.05 25-44.6 14.19l27 205.41s78.38 2.7 77.71-6.76l-16.19-124.31z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M162.09 190.31s7.68 8.24 19.52 9.27a47.49 47.49 0 0 1 19.18 5.71c7 3.89 14.63 9.55 17 16.45 4.73 13.51 34.46 35.81 48 31.08l-4.73 40.54s-38.51-2-45.27-16.89l11.49 144.6h-10.12s-5.41-39.19-9.46-47.3-12.16-52.7-12.84-63.52-10.81-73-19.6-83.79l-13.18-32.1z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M162.09 192.34s9 7.57 20.87 8.59a47.49 47.49 0 0 1 19.18 5.72c7 3.89 14.63 9.55 17 16.45 4.73 13.51 34.46 35.81 48 31.08l-4.73 40.54s-38.51-2-45.27-16.89l11.53 144.58h-10.16s-5.41-39.19-9.46-47.3-12.16-52.7-12.84-63.52-10.81-73-19.6-83.79l-14.53-31.42z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M162.09 190.99s9 7.57 20.87 8.59a47.49 47.49 0 0 1 19.18 5.71c7 3.89 14.63 9.55 17 16.45 4.73 13.51 34.46 35.81 48 31.08l-4.73 40.54s-38.51-2-45.27-16.89l11.53 144.59h-10.16s-5.41-39.19-9.46-47.3-12.16-52.7-12.84-63.52-10.81-73-19.6-83.79l-14.53-31.42z",
    fill: "#fd6f8d"
  }), React.createElement("path", {
    d: "M127.67 164.97c.88-6.4-.88-10.4-1.69-17.91l38.51 29.06s-.92 3.93-1.62 9.67a36.73 36.73 0 0 1-5.81.47c-13.48 0-23.1-10.47-29.39-21.29z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 157.02,
    cy: 147.74,
    r: 36.49,
    fill: "#fec3be"
  }), React.createElement("path", {
    d: "M196.84 111.98a46.19 46.19 0 0 0-3-18.06 4.5 4.5 0 0 1-.77 5.83 28.91 28.91 0 0 0-9.17-16.24c2.6.42 3.93 3.65 3.3 6.21s-2.61 4.53-4.51 6.35c.22-3.87-2.33-7.47-5.57-9.6s-7.1-3-10.87-3.94a6.3 6.3 0 0 1 4.17 6.46 1.8 1.8 0 0 1-.54 1.25 2.07 2.07 0 0 1-1.23.33 94.57 94.57 0 0 1-11.42-.24 119.71 119.71 0 0 0-14.06-.75c-14.76.62-29.46 10.65-32.75 25a57.43 57.43 0 0 0-1.07 10.54l-.68 18.13c-.21 5.28-.42 10.63.64 15.81a33.49 33.49 0 0 0 17.21 22.74c5.3-7.68 5.77-17.55 7.61-26.7a13.51 13.51 0 0 1 2.29-5.9c1.33-1.66 3.67-2.71 5.65-1.92s2.84 3.82 1.19 5.17c1.42 1.73 4.22.44 5.85-1.1a31.56 31.56 0 0 0 9.16-16.35c.66-3.15 1.32-7 4.36-8.09a8.2 8.2 0 0 1 3.27-.22c6.43.44 16.49 3.1 22.73 1.06 5.81-1.9 8.21-10.34 8.21-15.77z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M196.17 111.3a46.19 46.19 0 0 0-3-18.06 4.5 4.5 0 0 1-.77 5.83 28.91 28.91 0 0 0-9.17-16.24c2.6.42 3.93 3.65 3.3 6.21s-2.61 4.53-4.51 6.35c.22-3.87-2.33-7.47-5.57-9.6s-7.1-3-10.87-3.94a6.3 6.3 0 0 1 4.17 6.46 1.8 1.8 0 0 1-.54 1.25 2.07 2.07 0 0 1-1.23.33 94.57 94.57 0 0 1-11.42-.24 119.71 119.71 0 0 0-14.06-.75c-14.76.62-29.46 10.65-32.75 25a57.43 57.43 0 0 0-1.08 10.59l-.72 18.08c-.21 5.28-.42 10.63.64 15.81a33.49 33.49 0 0 0 17.21 22.74c5.3-7.68 5.77-17.55 7.61-26.7a13.51 13.51 0 0 1 2.29-5.9c1.33-1.66 3.67-2.71 5.65-1.92s2.84 3.82 1.19 5.17c1.42 1.73 4.22.44 5.85-1.1a31.56 31.56 0 0 0 9.16-16.35c.66-3.15 1.32-7 4.36-8.09a8.2 8.2 0 0 1 3.27-.22c6.43.44 16.49 3.1 22.73 1.06 5.85-1.89 8.26-10.34 8.26-15.77z",
    fill: "#fad375"
  }), React.createElement("path", {
    d: "M268.85 252.81s5.41 25-4.73 40.54l-5.74-.47 3.13-39.65z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M267.5 252.81s5.41 25-4.73 40.54l-5.74-.47 3.13-39.65z",
    fill: "#fd6f8d"
  }), React.createElement("path", {
    d: "M122.22 184.57l-43.55 37.5s-25.68 26.35-14.87 68.92c0 0 4.73 62.16 10.14 64.87 0 0 18.92 37.84 20.27 73.65 0 0 25.34-51 36.83-19.93s38.18 35.47 38.18 35.47l-14.9-183.79s-37.5-65.21-32.1-76.69z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M120.87 184.57l-43.58 37.5s-25.68 26.35-14.87 68.92c0 0 4.73 62.16 10.14 64.87 0 0 18.92 37.84 20.27 73.65 0 0 26.69-53.72 38.18-22.64s36.83 38.18 36.83 38.18l-14.87-183.79s-37.5-65.21-32.1-76.69z",
    fill: "#fd6f8d"
  }), React.createElement("path", {
    d: "M100.94 343.02s-10.81-7.43-28.38 12.84l43.24 78.38 14.53-22s-30.74-60.44-29.39-69.22z",
    fill: "#fec3be"
  }), React.createElement("path", {
    d: "M111.41 347.41s-23.91 26.86-33.24 22.55l-8.64-20.11 32.42-13.93z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M111.41 346.06s-23.91 26.86-33.24 22.59l-8.64-20.11 32.42-13.93z",
    fill: "#fd6f8d"
  }), React.createElement("path", {
    d: "M128.87 407.19s-11.38 23.33-17.46 24.69l8.78 10.14 12.84-24.37z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M129.55 407.86s-11.38 23.33-17.46 24.69l8.78 10.1 12.8-24.29z",
    fill: "#4d4981"
  }), React.createElement("path", {
    d: "M108.03 263.65s-1.35 48.65 4.05 66.89M217.5 273.08s-8.11-2.7-8.11-9.46",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M827.65 331.62c-.06 6.39.7 12.3 2.76 16.93l2 29s.5-.28 1.41-.72c-1.21 11-.34 31.15 21.26 34.94a3.66 3.66 0 0 0 1.33-.66 98 98 0 0 0 4-9.21l.25.08-.25 1.24 1.6.5c-7.79 16.88-6 52-4.27 55.44.73 1.44 1.28 5.68 1.69 10.49a119.67 119.67 0 0 1-1 28c-1 6.39-1.3 14.23 2 17.49 6 5.92 5.33 51.33 5.33 51.33a32.84 32.84 0 0 0 1.39 3l-2.06.29s0 17.77 3.33 30.27c1.92 7.19-.8 16.56-3.45 23.22a46.94 46.94 0 0 0-2.31 28.27c1.95 8.14 6 16.26 14.43 18.93 18.67 5.92 22.67-25 22.67-25s-.67-23.69 0-27c.21-1 1.17-3.84 2.41-7.26a90.46 90.46 0 0 0 5-39l-.77-8.32-3.62.52c-.06-.86-.11-1.76-.16-2.7s-.09-1.62-.13-2.47-.08-1.72-.12-2.62-.08-1.81-.11-2.74q0-.7-.05-1.41c-.15-4.26-.28-8.81-.39-13.31 0-2-.09-4-.12-5.95 0-1.46-.05-2.91-.07-4.31v-1.4c0-2.3-.06-4.5-.07-6.53v-1.2-2.26-1.06-2-1.73-1.48c0-2.47.1-3.57.2-2.66.33 3 1.33 21.06 0-2-1.08-18.59 15.66-62.91 22.15-79.3a57.75 57.75 0 0 1 6 3.58c2.22 25.86-.83 75.43-1.81 90v.06l-.19 2.71v.12l-.05.72v.52s-8.67 54-8.67 66.47c0 9.63-4.75 23.56-6.93 29.44-3.17 1.38-5.74 2.8-5.74 2.8l.67 49.36s-7.33 24.35 19.33 30.27 15.33-24.35 15.33-24.35l-2-21.72 9.33-33.56-2.62-.53c5.54-17.7 20.38-66.4 19.29-77.12-1.22-12 4.77-25.08 5.84-27.3l.16-.34c-5.72-11.8 11.67-74 19.6-100.84 9.89-4.72 17.06-8.4 17.06-8.4s-.2-.37-.55-1l.55-.28a132.29 132.29 0 0 1-10.23-25.09l.57-.58-.43-1.21c1.36-1.31 2.1-2.08 2.1-2.08s19.33 3.29 14.67-5.92-3.33-23-3.33-23v-50.58l9.33 3.07c17.55 2.89 20.69-16.71 20.6-31.74a116.66 116.66 0 0 0-1.26-17.62s-13.33-102-36.67-98.71c-21.86 3.08-41.08-9.71-43.43-11.35q-.43-1.32-.77-2.6a33 33 0 0 0 3.5-4.76c.73 0 1.47-.1 2.17-.18v-.59l.67-.07a17.22 17.22 0 0 1 4.76-12.43 16.51 16.51 0 0 1 4.38-3c3.23-1.51 6.88-2 10.05-3.62a11.09 11.09 0 0 0 3-2.29c2-1.8 3.3-4.31 2.61-6.81-.31-1.11-1-2.13-1-3.28 0-1.6 1.25-2.88 2-4.29 2.2-4.14.2-9.32-2.55-13.14s-6.28-7.42-7.29-12c-.41-1.88-.38-3.86-1-5.69-2-5.93-9.66-7.7-16-7.37s-13.14 1.68-18.62-1.44a17.45 17.45 0 0 0-3.34-1.9 9.16 9.16 0 0 0-4.21 0c-8 1.39-15.37 5.36-22 10a50.64 50.64 0 0 0-7.46 6.1 27.44 27.44 0 0 0-4 4.77c-2.7 4.17-4 9.49-2.31 14.16a14.33 14.33 0 0 0 4.83 6.48 32.62 32.62 0 0 0 6.71 46.18 38.1 38.1 0 0 1-3.76 5.14v-.26s-20.33 10.2-27.67 8.88c-7.16-1.29-25.76 10.62-25.38 34.46v1.84l-12 37.21a150.56 150.56 0 0 0-7.29 46.26s-11.02 29.94-10.81 52.8zm32.23 15.76l15.86-59.16v12.94l-10 35.54s-2 11.89-3.53 24.52z",
    transform: "translate(-158.33 -57.35)",
    fill: "url(#prefix__c)",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M748.84 498l.74 8.13a89.47 89.47 0 0 1-4.85 38.15c-1.19 3.35-2.12 6.11-2.32 7.1-.64 3.22 0 26.37 0 26.37s-3.86 30.23-21.87 24.44c-8.1-2.6-12-10.55-13.92-18.5a46.44 46.44 0 0 1 2.23-27.62c2.56-6.51 5.18-15.66 3.33-22.69-3.22-12.22-3.22-29.58-3.22-29.58z",
    fill: "#5a5773"
  }), React.createElement("path", {
    d: "M768.13 358.45s-25.08 61.1-23.79 83.6.32 4.82 0 1.93c-.57-5.15 0 56 1.93 63 0 0-26.37 19.29-36.66-6.43 0 0 .64-44.37-5.14-50.16-3.18-3.18-2.87-10.84-1.93-17.09a118.45 118.45 0 0 0 1-27.33c-.39-4.7-.93-8.84-1.63-10.25-1.93-3.86-3.86-47.59 7.72-59.81z",
    fill: "#605d82"
  }), React.createElement("path", {
    d: "M743.05 507.01c-1.93-7.07-2.5-68.18-1.93-63 .32 2.89 1.29 20.58 0-1.93s23.79-83.6 23.79-83.6L708.8 336.9c.26-.33.53-.64.8-.93l58.52 22.51s-25.08 61.1-23.79 83.6.32 4.82 0 1.93c-.57-5.15 0 56 1.93 63 0 0-10.53 7.7-20.88 6.88 9.21-.7 17.67-6.88 17.67-6.88z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M789.99 556.53l-9 32.8 1.93 21.22s10.93 29.58-14.79 23.79-18.65-29.58-18.65-29.58l-.64-48.23s10.29-5.79 14.79-5.14 26.36 5.14 26.36 5.14z",
    fill: "#5a5773"
  }), React.createElement("path", {
    d: "M834.37 343.02s-29.58 95.82-22.51 110.63c0 0-7.07 14.15-5.79 27s-20.58 81.67-20.58 81.67l-32.16-5.79s7.72-19.29 7.72-31.51 8.36-65 8.36-65 7.07-96.47-1.29-106.76z",
    fill: "#605d82"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M770.62 361.07c5.33 21.84-.56 102.21-.56 102.21s-8.36 52.73-8.36 65c0 9.33-4.49 22.77-6.62 28.61l-1.74-.31s7.72-19.29 7.72-31.51 8.36-65 8.36-65 5.38-73.42 1.2-99zM811.86 453.65l-.16.33c-.05-.33-.1-.68-.13-1a7.11 7.11 0 0 0 .29.67zM769.58 356.4a9.47 9.47 0 0 0-1.45-3.09l66.24-10.29s-.39 1.25-1.06 3.48z"
  })), React.createElement("path", {
    d: "M680.02 308.29s-9.65 36 19.29 41.16a3.52 3.52 0 0 0 1.29-.64s16.72-32.8 3.86-45.66zM798.36 69.05s-1.93 27 19.29 39.87-45 48.23-45 48.23l-34.75-55.3s14.77 1.93 23.77-23.79z",
    fill: "#a1616a"
  }), React.createElement("path", {
    d: "M812.5 110.85s-32.8 68.17-62.38 3.86l-45.66 226.38s70.74 21.87 71.38 32.16 71.38-26.37 71.38-26.37-15.43-28.3-11.58-45.66-23.14-190.37-23.14-190.37z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M812.5 109.57s-32.8 68.17-62.38 3.86L704.46 339.8s70.74 21.85 71.39 32.15 71.38-26.37 71.38-26.37-15.43-28.3-11.58-45.66-23.15-190.35-23.15-190.35z",
    fill: "#e1e7ef"
  }), React.createElement("path", {
    d: "M780.35 574.53s8.36-18.65-10.93-18.65-16.08 16.77-16.08 16.77zM736.62 526.3s7.72-19.94-11.58-20.58-9.65 18-9.65 18z",
    fill: "#5a5773"
  }), React.createElement("path", {
    d: "M753.02 95.1s-19.61 10-26.69 8.68-25.72 10.93-24.44 35.37l-11.62 36.5a148.9 148.9 0 0 0-7 45.21s-16.72 46.3-7.72 66.88l1.93 28.3s14.76-8.39 30.19-5.82l-3.86-23.15 17.36-65.6 28.94-70.1z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M753.02 93.81s-19.61 10-26.69 8.68-25.72 10.93-24.44 35.37l-11.62 36.47a148.9 148.9 0 0 0-7 45.21s-16.72 46.3-7.72 66.88l1.93 28.3s14.79-8.36 30.23-5.79l-3.86-23.15 17.36-65.6 28.94-70.1z",
    fill: "#67647e"
  }), React.createElement("path", {
    d: "M720.54 171.95v72.7l-9.65 34.73s-6.43 37.94-4.5 49.52 32.8 14.15 41.16 4.5 3.86-92 3.86-92l1.61-120.58-1.29-3.86z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M719.25 168.73v72.67l-9.65 34.73s-6.43 37.94-4.5 49.52 32.8 14.15 41.16 4.5 3.86-92 3.86-92l1.61-120.5z",
    fill: "#67647e"
  }), React.createElement("path", {
    d: "M848.84 229.19l-20.58 64 9.65 27.33s-45.66 48.23-74.6 25.08c0 0-3.22-98.4 3.22-121.55s37.3-101 37.3-101l6.43-20.58 34.08 19.29z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M850.45 225.97v63s-1.29 13.51 3.22 22.51-14.15 5.79-14.15 5.79-45.66 48.23-74.6 25.08c0 0-3.22-98.4 3.22-121.55s37.3-101 37.3-101l6.43-20.58 34.08 19.29z",
    fill: "#67647e"
  }), React.createElement("path", {
    fill: "#e6e6e6",
    d: "M809.396 191.268l-24.509 37.74-5.87-3.812 24.508-37.74z"
  }), React.createElement("ellipse", {
    cx: 937.75,
    cy: 288.24,
    rx: 14.57,
    ry: 8,
    transform: "rotate(-57.3 801.399 406.837)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 937.28,
    cy: 288.96,
    rx: 14.57,
    ry: 8,
    transform: "rotate(-57 805.232 406.108)",
    fill: "#e6e6e6"
  }), React.createElement("ellipse", {
    cx: 937.28,
    cy: 288.96,
    rx: 11.84,
    ry: 6.5,
    transform: "rotate(-57 805.232 406.108)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M800.61 88.02s19.61 14.47 42.12 11.25 35.37 96.47 35.37 96.47 8.36 51.45-18.65 46.95l-59.78-19.94s12.86-13.51 10.93-30.87l28.94 11.58-1.29-55.31z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M876.81 194.46s8.36 51.45-18.65 46.95l-59.81-19.94s12.86-13.51 10.93-30.87l28.94 11.58z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M810.67 197.38s-20-26.39-34.81-13.73 29.55 35.89 29.55 35.89z",
    fill: "#a1616a"
  }), React.createElement("path", {
    d: "M800.61 86.74s19.61 14.47 42.12 11.25 35.37 96.47 35.37 96.47 8.36 51.45-18.65 46.95l-59.78-19.94s12.86-13.51 10.93-30.87l28.94 11.58-1.29-55.31-32.8-27z",
    fill: "#67647e"
  }), React.createElement("path", {
    d: "M761.05 79.34l36.66-9s-1.91 2.16.32 10.61c-5.9 6.77-13.15 15.76-22.83 15.76a32 32 0 0 1-19.22-6.37 57.82 57.82 0 0 0 5.07-11z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 775.84,
    cy: 63.26,
    r: 32.16,
    fill: "#a1616a"
  }), React.createElement("path", {
    d: "M763.67 49.31c-7.46-1.27-15.66-4.58-18.16-11.72-1.6-4.57-.38-9.77 2.23-13.84s6.45-7.2 10.41-10c6.43-4.52 13.52-8.4 21.26-9.76a8.73 8.73 0 0 1 4.06 0 16.76 16.76 0 0 1 3.29 1.8c5.29 3.05 11.87 1.73 18 1.41s13.48 1.41 15.41 7.2c.6 1.79.56 3.72 1 5.56 1 4.5 4.39 8 7 11.75s4.62 8.82 2.42 12.86c-.75 1.37-2 2.63-2 4.19a13 13 0 0 0 1 3.21c.91 3.32-1.74 6.67-4.8 8.25s-6.58 2.07-9.7 3.54a17 17 0 0 0-9.47 15.74c-2.84.33-6.15.5-8.07-1.62-.86-.95-1.28-2.22-2.06-3.23-1-1.32-2.56-2.1-3.84-3.16-6.73-5.53-1.95-13.17-5.76-19.13-2-3.07-5.18-2.13-8.4-2.08a74.22 74.22 0 0 1-13.82-.97z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M764.3 48.65c-7.46-1.27-15.66-4.58-18.16-11.72-1.6-4.57-.38-9.77 2.23-13.84s6.45-7.2 10.41-10c6.43-4.52 13.52-8.4 21.26-9.76a8.73 8.73 0 0 1 4.06 0 16.76 16.76 0 0 1 3.29 1.8c5.29 3.05 11.87 1.73 18 1.41s13.48 1.41 15.41 7.2c.6 1.79.56 3.72 1 5.56 1 4.5 4.39 8 7 11.75s4.62 8.82 2.42 12.86c-.75 1.37-2 2.63-2 4.19a13 13 0 0 0 1 3.21c.91 3.32-1.74 6.67-4.8 8.25s-6.58 2.07-9.7 3.54a17 17 0 0 0-9.47 15.74c-2.84.33-6.15.5-8.07-1.62-.86-.95-1.28-2.22-2.06-3.23-1-1.32-2.56-2.1-3.84-3.16-6.73-5.53-1.95-13.17-5.76-19.13-2-3.07-5.18-2.13-8.4-2.08a74.22 74.22 0 0 1-13.82-.97z",
    fill: "#4a4347"
  }), React.createElement("path", {
    d: "M725.36 156.84s-7.07 36.66-3.86 50.81a47.15 47.15 0 0 1-.84 24.92M839.67 172.27s3.08 24.44-2.05 29.58",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M660.09 473.46a1.5 1.5 0 0 0 0-3 1.5 1.5 0 0 0 0 3z"
  }), React.createElement("path", {
    fill: "#e6e6e6",
    d: "M351.929 208.08l41.664 17.002-2.645 6.481-41.664-17.003z"
  }), React.createElement("ellipse", {
    cx: 554.85,
    cy: 287.38,
    rx: 8,
    ry: 14.57,
    transform: "rotate(-67.8 433.041 376.511)",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 555.65,
    cy: 287.7,
    rx: 8,
    ry: 14.57,
    transform: "rotate(-67.8 433.828 376.835)",
    fill: "#e6e6e6"
  }), React.createElement("ellipse", {
    cx: 555.65,
    cy: 287.7,
    rx: 6.5,
    ry: 11.84,
    transform: "rotate(-67.8 433.828 376.835)",
    opacity: 0.1
  }));
};

UndrawTasting.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawTasting;